import React, {FunctionComponent, useContext} from 'react';
import './CommentTile.scss';
import {Comment} from '../../models/comment.model';
import {UserAvatar} from '../UserAvatar/UserAvatar';
import styled from 'styled-components';
import {ThemeContext} from '../../context/ThemeContext';
import {Theme} from '../../models/theme.model';

interface CommentTileProps {
    comment: Comment;
}

const StyledCommentTile = styled.div`
  &&& {
    
  }
`;

export const CommentTile: FunctionComponent<CommentTileProps> = (props) => {
    const {comment} = props;
    const theme: Theme = useContext(ThemeContext).theme;

    return (
        <StyledCommentTile theme={theme} className='comment-tile'>
            <div className='comment-logo'>
                <UserAvatar initials={comment.author_initials} avatar={comment.author_logo_src}/>
            </div>

            <div className='comment-content'>
                <header>
                    <div className='comment-author'>
                        {comment.author_display_name}
                    </div>

                    <div className='comment-creation-date'>
                        {comment.created_at}
                    </div>
                </header>

                <main>
                    <div className='comment-text'>
                        {comment.text}
                    </div>
                </main>
            </div>
        </StyledCommentTile>
    );
};